<template lang="pug">
action-bar-ex(
  :entity="entity"
  :actions="actions"

  allow-title
  allow-close

  @perform="opts => $emit('perform', opts)"
)
  //- BOTÃO DE FILTRO
  template(#navbar v-if="!showFilter")

  template(#right)

    //- BOTÃO DE ATUALIZAR
    v-tooltip(bottom)
      template(#activator="{ on, attrs }")
        v-btn.mx-1(
          icon
          v-bind="attrs"
          v-on="on"
          @click="$emit('refresh')"
        )
          v-icon mdi-refresh
      span
        span.text-md.font-weight-medium Atualizar
        br
        span.font-weight-light Sincroniza os dados da grade com o servidor de dados.

    //- BOTÃO DE CONFIGURAÇÃO DO AUTO-REFRESH
    v-menu(
      v-model="menu"
      offset-y
      dense
    )
      template(#activator="{ on, attrs }")
        v-tooltip(bottom)
          template(#activator="{ on: onTooltip, attrs: tooltipAttrs }")
            v-btn.mx-1(
              icon
              v-bind="{ ...attrs, ...tooltipAttrs }"
              v-on="{ ...on, ...onTooltip }"
            )
              v-icon(:color="autoRefresh > 0 ? 'accent' : null") mdi-timer-refresh-outline

          span
            span.text-md.font-weight-medium Atualização Automática {{ autoRefresh > 0 ? `(${autoRefresh} segundos)` : null }}

            br

            span.font-weight-light.text-no-wrap(v-if="autoRefresh > 0")
              v-icon(small left color="accent") mdi-clock-outline
              | Configurado para sincronização automática de dados a cada {{ autoRefresh }} segundos.

            span.font-weight-light.text-no-wrap(v-else)
              v-icon(small left) mdi-cursor-pointer
              | Configurado para sincronização manual de dados da página.

      v-list(dense)
        v-list-item(
          v-for="option in autoRefreshOptions"
          :key="option.value"
          @click="() => setAutoRefresh(option)"
        )
          v-list-item-avatar.mx-0.px-0
            v-icon(small v-if="autoRefresh === option.value") mdi-check
          v-list-item-content
            v-list-item-title.text-no-wrap {{ option.title }}
          v-list-item-avatar
            v-icon(small) {{ option.value > 0 ? 'mdi-clock-outline' : 'mdi-cursor-pointer' }}

    //- BOTÃO DE FILTRO
    grid-ex-filter-btn(
      v-if="!showFilter"
      v-bind="$props"
      @input="showFilter => $emit('input',showFilter)"
    )

    //- MENU DE AÇÕES
    v-tooltip(bottom)
      template(#activator="{ on, attrs }")
        div(
          v-bind="attrs"
          v-on="on"
        )
          action-bar-ex-menu(
            v-bind="$props"
            left
            @perform="opts => $emit('perform', opts)"
          )

            v-divider(v-if="actions.menu.all.length > 0")

            action-bar-ex-menu-item(
              v-bind="$props"
              title="Exportar para Excel"
              icon="mdi-export"
              right-icon="mdi-microsoft-excel"
              @click="$emit('exportToFile', { format: 'excel' })"
            )

            action-bar-ex-menu-item(
              v-bind="$props"
              title="Exportar para CSV"
              icon="mdi-export"
              right-icon="fa-file-csv"
              @click="$emit('exportToFile', { format: 'csv' })"
            )

      span
        span.text-md.font-weight-medium Menu
        br
        span.font-weight-light Menu de ações disponíveis para a grade.

</template>

<script>
import ActionBarEx from '@/components/commons/action-bar-ex/ActionBarEx'
import ActionBarExMenu from '@/components/commons/action-bar-ex/ActionBarExMenu'
import ActionBarExMenuItem from '@/components/commons/action-bar-ex/ActionBarExMenuItem'
import GridExFilterBtn from './GridExFilterBtn'

export default {
  components: {
    ActionBarEx,
    ActionBarExMenu,
    ActionBarExMenuItem,
    GridExFilterBtn,
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,

    busy: Boolean,

    /**
     * Visibilidade do filtro, alternada por este botão.
     */
    value: Boolean,

    /**
     * Formulário de filtro.
     * @type {Keep.Paper.Design.Form}
     */
    filter: Object,

    /**
     * Ações disponíveis no menu.
     *
     * Esta propriedade recebe um objeto que contém a estrutura de ações organizadas no menu.
     *
     * @type {Object}
     * @property {Array} all - Todas as ações no menu.
     * @property {Array} main - Ações principais no menu.
     * @property {Array} side - Ações secundárias no menu.
     * @property {Array} rest - Outras ações no menu.
     * @property {Array} categories
     *    - Categorias personalizadas no menu, cada uma contendo um nome e um conjunto de ações.
     *
     * @example
     * {
     *   menu: {
     *     all: [...], // Todas as ações da página
     *     main: [...], // Ações principais da página
     *     side: [...], // Ações secundárias da página
     *     rest: [...], // Outras ações da página
     *     categories: [
     *       { name: 'Category1', actions: [...] }, // Categorias personalizadas
     *       { name: 'Category2', actions: [...] },
     *       // ...
     *     ]
     *   },
     *   pins: {
     *     all: [...], // Todas as ações fixadas da página
     *     main: [...], // Ações principais fixadas da página
     *     side: [...], // Ações secundárias fixadas da página
     *     rest: [...], // Outras ações fixadas da página
     *     categories: [
     *       { name: 'Category1', actions: [...] }, // Categorias personalizadas
     *       { name: 'Category2', actions: [...] },
     *       // ...
     *     ]
     *   },
     *   states: {
     *     all: [...], // Todos os monitores de estado da página
     *     main: [...], // Monitores de estado da página
     *     side: [...], // Monitores de estado secundários da página
     *     rest: [...], // Outros monitores de estado da página
     *     categories: [
     *       { name: 'Category1', actions: [...] }, // Categorias personalizadas
     *       { name: 'Category2', actions: [...] },
     *       // ...
     *     ]
     *   }
     * }
     */
    actions: Object,

    /**
     * Tempo de atualização automática da página.
     */
    autoRefresh: Number,
  },

  data: () => ({
    menu: false,
  }),

  computed: {
    autoRefreshOptions() {
      let options = [
        { value: 0, title: 'Atualização manual' },
        { value: 3, title: 'A cada 3 segundos' },
        { value: 5, title: 'A cada 5 segundos' },
        { value: 10, title: 'A cada 10 segundos' },
        { value: 30, title: 'A cada 30 segundos' },
        { value: 60, title: 'A cada 1 minuto' },
      ]
      // Se a opcao this.autoRefresh nao estiver na lista adiciona-a e ordena a lista
      if (!options.find(o => o.value === this.autoRefresh)) {
        options.push({ value: this.autoRefresh, title: `A cada ${this.autoRefresh} segundos` })
        options = options.sort((a, b) => a.value - b.value)
      }
      return options
    },

    showFilter() {
      return this.value && this.filter && this.filter.fields?.length > 0
    },
  },

  methods: {
    setAutoRefresh(option) {
      this.$emit('setAutoRefresh', { autoRefresh: option.value || 0 })
      this.$emit('refresh')
    },
  },
}
</script>